import { type FC, useContext } from 'react';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';

// helpers
import { replaceHrefValueWithLocale, sanitizeHtml } from 'src/lib/utils';

// contexts
import { LocaleContext } from 'src/contexts';

interface Props {
  body: string;
  entryId?: string;
  as?: 'div' | 'span';
  className?: string;
}

const RawHtml: FC<Props> = ({ body, entryId, as = 'div', className }) => {
  const Wrapper = as;
  const locale = useContext(LocaleContext);
  const inspectorProps = useContentfulInspectorMode({ entryId });

  return (
    <Wrapper
      {...(entryId ? inspectorProps({ fieldId: 'body' }) : null)}
      className={className}
      dangerouslySetInnerHTML={{
        __html: replaceHrefValueWithLocale({ locale, str: sanitizeHtml(body) }),
      }}
    />
  );
};

export default RawHtml;
